import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@abyss/web/ui/Modal';
import { IconBrand } from '@abyss/web/ui/IconBrand';
import { styled } from '@abyss/web/tools/styled';

const StyledModalSectionContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '$lg',
});

export const ApiErrorModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      css={{
        'abyss-modal-header-container': { marginTop: '$md' },
      }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <StyledModalSectionContainer>
        <Modal.Section
          css={{
            'abyss-modal-section-root': { paddingBottom: '0px' },
          }}
        >
          <IconBrand size="58px" icon="alert" brand="uhc" />
        </Modal.Section>
        <Modal.Section>
          <strong>The system is unable to respond at the moment.</strong>
          <p>Please try refreshing the page or try again at a later time.</p>
        </Modal.Section>
      </StyledModalSectionContainer>
    </Modal>
  );
};

ApiErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

ApiErrorModal.defaultProps = {
  isOpen: false,
};
